import { render } from "./NewKeyResultHeader.vue?vue&type=template&id=64cc5836&scoped=true"
import script from "./NewKeyResultHeader.vue?vue&type=script&lang=js"
export * from "./NewKeyResultHeader.vue?vue&type=script&lang=js"

import "./NewKeyResultHeader.vue?vue&type=style&index=0&id=64cc5836&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64cc5836"

export default script